export const PINNED_PANEL_CONTAINER_ID = 'PINNED_PANEL_CONTAINER_ID';
